import React from 'react'
import {connect} from 'react-redux'
import 'moment/locale/pt-br'
import '../../../css/components/react-datepicker.css';
import pt from 'date-fns/locale/pt';
import Titulo from '../../comum/Titulo';
import Autorizacao from '../../../security/Autorizacao';
import {
    getFiscalEmbarque,
    getGestorEmpresa,
    getOperadorEmpresa,
    getPerfisVendedores,
    getFinanceiroEmpresa,
    getAdminEmpresa,
    PERFIL_ADMIN
} from '../../../security/securityContext';
import {registerLocale, setDefaultLocale} from 'react-datepicker';
import DatePicker from 'react-datepicker/es';
import buscarRelatoriItinerarios from '../../../actions/itinerario/buscarRelatorioitinerarios';
import moment from 'moment';
import limparRelatorioItinerarios from '../../../actions/itinerario/limparRelatorioItinerarios';
import elementosPaginaAtual from '../../../util/elementosPaginaAtual';
import CabecalhoRodapeTabela from '../../comum/CabecalhoRodapeTabela';
import OpcoesPaginacaoRelatorioItinerarios from './OpcoesPaginacaoRelatorioItinerarios';
import SetasPaginacaoRelatorioItinerarios from './SetasPaginacaoRelatorioItinerarios';
import alterarRegistrosPorPagina from '../../../actions/resumo-financeiro/alterarRegistrosPorPaginaResumoFinanceiro';
import determinarPaginaAtual from '../../../actions/resumo-financeiro/determinarPaginaAtualResumoFinanceiro';
import ExportarCsv from '../../comum/ExportarCSV';
import filtrarRelatorioItinerarios from '../../../actions/itinerario/filtrarRelatorioItinerarios';

registerLocale('pt', pt);
setDefaultLocale('pt');

export class PainelRelatorioItinerarios extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tipoResumo: 'tipoEmpresaAtual'
        };
        this.handleChangeTipoBusca = this.handleChangeTipoBusca.bind(this);
        this.submeterBusca = this.submeterBusca.bind(this);

    }


    componentDidMount() {
        this.props.alterarRegistrosPorPagina(50);
        this.props.determinarPaginaAtual(1);
        this.props.limparRelatorioItinerarios();
    }

    submeterBusca(event) {
        this.props.alterarRegistrosPorPagina(50);
        this.props.determinarPaginaAtual(1);
        this.props.filtrarItinerarios(this.props.relatorioItinerariosInicial, event.target.value);
    }

    componentDidUpdate(prevProps) {
        if (this.props.relatorioItinerarios !== prevProps.itinerarios) {
            this.props.determinarPaginaAtual(1);
        }
    }


    recuperarDadosExportacao() {
        const itens = [];
        if (this.props.relatorioItinerarios && this.props.relatorioItinerarios.length > 0) {
            this.props.relatorioItinerarios.forEach((itinerario) => {
                const valores = this.state.tipoResumo !== 'tipoEmpresaAtual' ? [itinerario.nomeEmpresa, itinerario.dataHoraPartida,
                    itinerario.quantidadeAssentos,
                    itinerario.quantidadeReservas,
                    itinerario.prefixoRota ? itinerario.prefixoRota : 'Não informado',
                    itinerario.rota,
                    itinerario.prestadorRota ? itinerario.prestadorRota : 'Não informado',
                    itinerario.veiculo,
                    itinerario.motoristas ? itinerario.motoristas : 'Não informado'
                ] : [itinerario.dataHoraPartida,
                    itinerario.quantidadeAssentos,
                    itinerario.quantidadeReservas,
                    itinerario.prefixoRota ? itinerario.prefixoRota : 'Não informado',
                    itinerario.rota,
                    itinerario.prestadorRota ? itinerario.prestadorRota : 'Não informado',
                    itinerario.veiculo,
                    itinerario.motoristas ? itinerario.motoristas : 'Não informado'
                ];
                itens.push(valores.concat());
            });
        }
        return (
            [[this.state.tipoResumo === 'tipoEmpresaAtual' ? 'Empresa: ' + this.props.empresaSelecionada.nomeFantasia : null]].concat([['Período: ' + moment(this.state.dataInicio)
                .format('DD/MM/YYYY') + ' - ' + moment(this.state.dataFim)
                .format('DD/MM/YYYY')]]
                .concat([['Emissor: ' + this.props.nomeUsuario]]
                    .concat([this.recuperarCabecalho()].concat(itens))))
        )
    }

    recuperarCabecalho() {
        return this.state.tipoResumo === 'tipoEmpresaAtual' ? ['Data/Hora partida', 'Total de assentos', 'Total de assentos vendidos', 'Prefixo', 'Rota', 'Delimitação',
            'Veículo', 'Motoristas'] : ['Empresa', 'Data/Hora partida', 'Total de assentos', 'Total de assentos vendidos', 'Prefixo', 'Rota', 'Delimitação',
            'Veículo', 'Motoristas'];
    }


    exibirRelatorio() {
        if (this.props.relatorioItinerarios && this.props.relatorioItinerarios.length) {
            const itinerarios = elementosPaginaAtual(
                this.props.relatorioItinerarios,
                this.props.paginaAtual,
                this.props.registrosPorPagina
            );
            return (
                <CabecalhoRodapeTabela OpcoesPaginacao={OpcoesPaginacaoRelatorioItinerarios}
                                       BotoesPaginacao={SetasPaginacaoRelatorioItinerarios}
                                       empresas={this.props.relatorioItinerarios}>
                    <div className='table-responsive'>
                        <table className="table table-striped table-bordered" style={{backgroundColor: '#FFF'}}>
                            <thead>
                            <tr style={{borderBottom: '1px solid #c8ced3'}}>
                                <th colSpan={this.state.tipoResumo === 'tipoEmpresaAtual' ? 7 : 8}
                                    style={{borderRight: '0'}}>
                                    {this.state.tipoResumo === 'tipoEmpresaAtual'
                                        ?
                                        <React.Fragment><strong>Empresa: </strong>{this.props.empresaSelecionada.nomeFantasia}
                                        </React.Fragment> : ''}
                                    <br/>
                                    <strong> Período: </strong>{moment(this.state.dataInicio)
                                    .format('DD/MM/YYYY') + ' - ' + moment(this.state.dataFim)
                                    .format('DD/MM/YYYY')}
                                    <br/>
                                    <strong>Emissor: </strong>{this.props.nomeUsuario}
                                </th>
                                <th style={{
                                    borderLeft: '0',
                                    textAlign: 'right',
                                    verticalAlign: 'middle'
                                }}>
                                    <ExportarCsv dadosCsv={this.recuperarDadosExportacao()}
                                                 nomeArquivo={`relatório de itinerários-${moment(this.state.dataInicio)
                                                     .format('DD/MM/YYYY') + '-' + moment(this.state.dataFim)
                                                     .format('DD/MM/YYYY')}.csv`}/><span className='mr-2'/>
                                </th>
                            </tr>
                            <tr className='border-top-1'>
                                {this.state.tipoResumo === 'tipoEmpresaAtual' ? null : <th scope='col'>Empresa</th>}
                                <th scope="col">Data/Hora partida</th>
                                <th scope="col">Total de assentos</th>
                                <th scope="col">Total de assentos vendidos</th>
                                <th scope="col">Prefixo</th>
                                <th scope="col">Rota</th>
                                <th scope="col">Delimitação</th>
                                <th scope="col">Veículo</th>
                                <th scope="col">Motoristas</th>
                            </tr>
                            </thead>
                            <tbody>
                            {itinerarios.map(itinerario =>
                                <tr key={`relatorio-itinerario-${itinerario.id}`}>
                                    {this.state.tipoResumo === 'tipoEmpresaAtual' ? null :
                                        <td><span>{itinerario.nomeEmpresa}</span></td>}
                                    <td>
                                        <span> {itinerario.dataHoraPartida}</span>
                                    </td>
                                    <td>
                                        <span>{itinerario.quantidadeAssentos}</span>
                                    </td>
                                    <td>
                                        <span>{itinerario.quantidadeReservas}</span>
                                    </td>
                                    <td>
                                        <span>{itinerario.prefixoRota ? itinerario.prefixoRota : 'Não informado'}</span>

                                    </td>
                                    <td>
                                        <span>{itinerario.rota}</span>
                                    </td>
                                    <td>
                                        <span>{itinerario.prestadorRota ? itinerario.prestadorRota : 'Não informado'}</span>
                                    </td>
                                    <td>
                                        <span>{itinerario.veiculo}</span>
                                    </td>
                                    <td>
                                        <span>{itinerario.motoristas ? itinerario.motoristas : 'Não informado'}</span>
                                    </td>
                                </tr>)}
                            </tbody>
                        </table>
                    </div>
                </CabecalhoRodapeTabela>
            )
        }
    }

    buscar() {
        this.props.buscarRelatoriItinerarios(this.props.empresaSelecionada.id, this.state.dataInicio, this.state.dataFim, this.state.tipoResumo);
    }

    handleChangeTipoBusca(event) {
        this.setState({tipoResumo: event.target.id});
        this.props.limparRelatorioItinerarios();
    }

    exibirCampoBusca() {
        if (this.props.relatorioItinerariosInicial.length) {
            return (<React.Fragment>
                <div className="input-group mb-3 mt-3">
         <span className="input-group-prepend">
          <button id="btn-campo-busca-processo" type="submit"
                  className="input-group-text bg-white btn-campo-busca" disabled={true}>
            <i className="material-icons">&#xe8b6;</i>
          </button>
        </span>
                    <input className="form-control form-control-lg campo-busca"
                           type="text"
                           id="campo-busca-legitimado"
                           onChange={this.submeterBusca}
                           autoComplete="off"
                           placeholder="Buscar na lista abaixo"/>
                </div>
            </React.Fragment>);
        }
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[getOperadorEmpresa(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getFiscalEmbarque(this.props.empresaSelecionada.id),
                getFinanceiroEmpresa(this.props.empresaSelecionada.id),
                ...getPerfisVendedores(this.props.empresaSelecionada.id), PERFIL_ADMIN]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="container-padrao" style={{height: '100%'}}>
                    <Titulo texto="Itinerários" urlRetorno="/menu-relatorio"/>
                    <fieldset className='border col-12 justify-content-center' style={{backgroundColor: '#FFF'}}>
                        <div className='row mt-5 mb-5'>
                            <div className='col-md-3 col-12 col-sm-12'>
                                <span className="label-data">De</span>
                                <DatePicker
                                    value={this.state.dataInicio}
                                    className='form-control form-control-lg campo-busca data-itinerario'
                                    locale="pt-BR"
                                    onChange={date => {
                                        this.setState({dataInicio: date});
                                        this.props.limparRelatorioItinerarios();
                                    }
                                    }
                                    selected={this.state.dataInicio}
                                    dateFormat="dd/MM/yyyy"/>
                            </div>
                            <div className='col-md-3 col-12 col-sm-12'>
                                <span className="label-data ">Até</span>
                                <DatePicker
                                    className='form-control form-control-lg campo-busca data-itinerario'
                                    locale="pt-BR"
                                    value={this.state.dataFim}
                                    selected={this.state.dataFim}
                                    onChange={date => {
                                        this.setState({dataFim: date});
                                        this.props.limparRelatorioItinerarios();
                                    }
                                    }
                                    dateFormat="dd/MM/yyyy"/>
                            </div>
                            <div className='col-md-4 col-12 col-sm-12'>
                                <span className="label-data ">Tipo de resumo:</span>
                                <div className="form-check ml-3">
                                    <input className="form-check-input" type="radio" id="tipoEmpresaAtual"
                                           onChange={this.handleChangeTipoBusca}
                                           checked={this.state.tipoResumo === 'tipoEmpresaAtual'}/>
                                    <label className="form-check-label" htmlFor="tipoEmpresaAtual">
                                        Empresa atual
                                    </label>
                                </div>
                                <Autorizacao perfisPermitidos={[getOperadorEmpresa(this.props.empresaSelecionada.id),
                                getAdminEmpresa(this.props.empresaSelecionada.id),
                                getGestorEmpresa(this.props.empresaSelecionada.id),
                                getFiscalEmbarque(this.props.empresaSelecionada.id),            
                                PERFIL_ADMIN]}>
                                <div className="form-check ml-3">
                                    <input className="form-check-input" type="radio" id="tipoTodasEmpresa"
                                           onChange={this.handleChangeTipoBusca}
                                           checked={this.state.tipoResumo === 'tipoTodasEmpresa'}/>
                                    <label className="form-check-label" htmlFor="tipoTodasEmpresa">
                                        Todas as empresas
                                    </label>
                                </div>
                                </Autorizacao>         
                            </div>
                            <div className='col-md-2 col-12 col-sm-12 mt-2 d-flex align-items-center'>
                                <span className="label-data"> </span>
                                <button disabled={!this.state.dataInicio || !this.state.dataFim} type="submit"
                                        onClick={() => this.buscar()} className="btn btn-laranja">
                                    Buscar
                                </button>
                            </div>
                        </div>
                    </fieldset>
                    <div className="lista-table mt-5">
                        {this.exibirCampoBusca()}
                        {this.exibirRelatorio()}
                    </div>
                </div>
            </Autorizacao>
        )
    }
}


export const mapStateToProps = state => (
    {
        empresaSelecionada: state.empresaSelecionada,
        relatorioItinerarios: state.relatorioItinerarios,
        relatorioItinerariosInicial: state.relatorioItinerariosInicial,
        nomeUsuario: state.authentication.nomeUsuarioComNumero,        
        paginaAtual: state.paginaAtualRelatorioItinerarios,
        registrosPorPagina: state.registrosPorPaginaRelatorioItinerarios
    });


export default connect(mapStateToProps,
    {
        buscarRelatoriItinerarios,
        limparRelatorioItinerarios,
        alterarRegistrosPorPagina,
        determinarPaginaAtual,
        filtrarItinerarios: filtrarRelatorioItinerarios
    })(PainelRelatorioItinerarios)
